export default {
  methods: {
    onBridgeReady() {
      // eslint-disable-next-line
      WeixinJSBridge.call('hideOptionMenu');
    },
  },
  beforeDestroy() {
    document.removeEventListener('WeixinJSBridgeReady', this.onBridgeReady);
  },

  mounted() {
    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady);
  },
};
